import React, { useState } from 'react';
import CardList from '../components/CardList';
import { useCard } from '../context/CardContext';
import '../styles/Dashboard.css'; // Ensure CSS is properly linked

export default function Dashboard() {
    const { addCard } = useCard();
    const [newCardName, setNewCardName] = useState("");

    const handleAddCard = async () => {
        if (!newCardName) {
            alert("Please enter a card name.");
            return;
        }
        try {
            await addCard(newCardName);
            setNewCardName("");
        } catch (error) {
            console.error("Error adding card:", error);
            alert("Failed to add card. Please try again.");
        }
    };

    return (
        <div className="min-h-screen bg-dark text-white p-4">
            <div className="container mt-5">
                <h2 className="mb-4">Dashboard</h2>
                <div className="input-group mb-3">
                    <input type="text" className="form-control" placeholder="New Card Name"
                        value={newCardName} onChange={e => setNewCardName(e.target.value)}
                    />
                    <button className="btn btn-outline-secondary" type="button" onClick={handleAddCard}>
                        Add Card
                    </button>
                </div>
                <CardList />
            </div>
        </div>
    );
}
